import { app } from '@ekuaibao/whispered';
import { session } from '@ekuaibao/session-info';
import qs from 'qs';
import { Fetch } from '@ekuaibao/fetch';
export function initDatafluxRum() {
    if (!window.HSM || dataFluxRumBlackList())
        return;
    var user = session.get('user') || {};
    var _a = qs.parse(location.search.slice(1)), ekbCorpId = _a.ekbCorpId, corpId = _a.corpId;
    window.HSM.datafluxRum.setGlobalContext({
        corpId: ekbCorpId || corpId || user.corpId,
        env: window.__PLANTFORM__,
        platform: window.__PLANTFORM__,
        trackInteractions: true,
        traceType: 'ddtrace',
        'user-agent': window.navigator.userAgent,
    });
    app.datafluxRum = window.HSM.datafluxRum;
}
export function addRumAction(actionName, data) {
    if (!window.HSM || dataFluxRumBlackList())
        return;
    window.HSM.datafluxRum.addAction(actionName, data);
}
var dataFluxRumBlackList = function () {
    var blackList = ['ID_3vGykiPD7y0'];
    return blackList.includes(Fetch.ekbCorpId);
};
